define(function (require) {

    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    let ImageParsingHelper = function () {

        const CONSTS = {
            TIFF_TAGS: {
                ORIENTATION: 0x0112  //274
            },
            SOI_MARKER: 0xFFD8,
            APP1_MARKER: 0xFFE1,
            EXIF_HEADER_MARKER: 0x45786966,
            TIFF_HEADER_MARKER: 0x4949,
            MAX_THUMB_WIDTH: 130,
            MAX_THUMB_HEIGHT: 130,
            THUMB_FORMAT: 'image/jpeg'
        };

        // Resize image based on configuration - default 800 pixels
        const previewSize = lpTag.WebAgent.logicController.getImageResize();

        function fixOrientation(data, callback) {
            if (!data || !(data instanceof Blob)) {
                callback(data);
                return;
            }
            var cb = _resetOrientation.bind(this, data, _resizeImage.bind(this, callback));

            try {
                getImageOrientation(data, cb);
            }
            catch (e) {
                callback(data);
            }
        }

        /**
         * Resets the image orientation to be TopLeft, flip & mirroring the image according to the current orientation state
         *
         * Guide on parsing image data in JS:
         *  http://code.flickr.net/2012/06/01/parsing-exif-client-side-using-javascript-2/

         * TIFF tags:
         *  https://www.awaresystems.be/imaging/tiff/tifftags/baseline.html

         Here is what the letter F would look like in each orientation:

         1            2         3       4                5            6               7               8

         888888     888888        88      88          8888888888    88                      88    8888888888
         88             88        88      88          88  88        88  88              88  88        88  88
         8888         8888      8888      8888        88            8888888888      8888888888            88
         88             88        88      88
         88             88    888888      888888




         ctx.transform(a, b, c, d, e, f);

         a - Horizontal scaling
         b - Horizontal skewing
         c - Vertical skewing
         d - Vertical scaling
         e - Horizontal moving
         f - Vertical moving

         The transformation matrix is described by:
         //        a    c    e
         //     [  b    d    f   ]
         //        0    0    1

         * @param selectedImage
         * @param callback
         * @param srcOrientation
         * @private
         */
        function _resetOrientation(selectedImage, callback, srcOrientation) {
            if (srcOrientation < 2) {
                callback(selectedImage);
            }
            else {
                var reader = new FileReader();

                reader.onloadend = function () {

                    var img = new Image();

                    img.onload = function () {
                        var width = img.width,
                            height = img.height,
                            canvas = document.createElement('canvas'),
                            ctx = canvas.getContext('2d');

                        // set proper canvas dimensions before transform & export
                        if (4 < srcOrientation && srcOrientation < 9) {
                            canvas.width = height;
                            canvas.height = width;
                        } else {
                            canvas.width = width;
                            canvas.height = height;
                        }

                        //transform context before drawing image
                        switch (srcOrientation) {
                            case 2:
                                //flip horizontal
                                ctx.transform(-1, 0, 0, 1, width, 0);
                                break;
                            case 3:
                                //rotate 180
                                ctx.transform(-1, 0, 0, -1, width, height);
                                break;
                            case 4:
                                //flip vertical
                                ctx.transform(1, 0, 0, -1, 0, height);
                                break;
                            case 5:
                                //transpose - operator which flips a matrix over its diagonal, that is it switches the row and column indices of the matrix.
                                ctx.transform(0, 1, 1, 0, 0, 0);
                                break;
                            case 6:
                                //rotate 90
                                ctx.transform(0, 1, -1, 0, height, 0);
                                break;
                            case 7:
                                //transverse
                                ctx.transform(0, -1, -1, 0, height, width);
                                break;
                            case 8:
                                //rotate 270
                                ctx.transform(0, -1, 1, 0, 0, width);
                                break;
                        }

                        ctx.drawImage(img, 0, 0);

                        //return the data to Blob object of the same image type (png / jpg...)
                        if (canvas.toBlob) {
                            canvas.toBlob(callback, selectedImage.type);
                        } else {
                            callback(selectedImage);
                        }
                    };

                    img.onerror = function (ev) {
                        callback(selectedImage);
                    };
                    // In case we were called with invalid data
                    if (reader && reader.result && reader.result !== 'data:') {
                        img.src = reader.result;
                    } else {
                        callback(selectedImage);
                    }

                };

                try {
                    reader.readAsDataURL(selectedImage);
                } catch (e) {
                    callback(selectedImage);
                }
            }
        }

        /**
         * Resizes the image according to the configuration, with a default resize of 800 pixels for the larger dimension
         * @private
         */
        function _resizeImage(callback, selectedImage) {
            var reader = new FileReader();

            reader.onloadend = function () {
                var img = new Image();

                img.onload = function () {

                    var ratio,
                        canvas = document.createElement('canvas'),
                        ctx = canvas.getContext('2d');

                    canvas.width = img.width;
                    canvas.height = img.height;

                    // Resize image based on configuration - default 800 pixels
                    // We want the longer dimension to be resized to the target size.
                    // Also, we don't want to enlarge the photo - so we default to a ration of 1.
                    ratio = Math.min(previewSize / canvas.width, previewSize / canvas.height, 1);
                    canvas.width = canvas.width * ratio;
                    canvas.height = canvas.height * ratio;

                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                    //return the data to Blob object of the same image type (png / jpg...)
                    if (canvas.toBlob) {
                        canvas.toBlob(callback, selectedImage.type);
                    } else {
                        callback(selectedImage);
                    }
                };
                img.onerror = function (ev) {
                    callback(selectedImage);
                };
                // In case we were called with invalid data
                if (reader && reader.result && reader.result !== 'data:') {
                    img.src = reader.result;
                } else {
                    callback(selectedImage);
                }
            };

            try {
                reader.readAsDataURL(selectedImage);
            } catch (e) {
                callback(selectedImage);
            }
        }

        /**
         *  Extract orientation metadata from jpg images
         *  Orientation is metadata tag in Exif directory. This metadata has valid values from 1-8.
         *
         *  not jpeg -   (-2)
         *  not defined -  (-1)
         *  TopLeft  - 1
         *  TopRight  - 2
         *  BottomRight  - 3
         *  BottomLeft  - 4
         *  LeftTop  - 5
         *  RightTop  - 6
         *  RightBottom  - 7
         *  LeftBottom  - 8
         *
         * @param file
         * @param callback
         */
        function getImageOrientation(file, callback) {
            _getTiffTags(file, function (tags) {
                var orientation = -1;
                if (tags) {
                    orientation = tags[CONSTS.TIFF_TAGS.ORIENTATION];
                }
                callback(orientation);
            });
        }

        /**
         * parse the tiff header tags from the image APP1 segment
         * loop through all bytes and search for the current headers
         *
         * @param file
         * @param callback
         * @private
         */
        function _getTiffTags(file, callback) {
            if (!(file instanceof Blob)) {
                return callback();
            }

            var reader = new FileReader();

            reader.onload = function (e) {

                var view = new DataView(e.target.result);

                //check the the length of the view buffer
                //The getUint16() method gets an unsigned 16-bit integer
                if (view.buffer.byteLength < 16) {
                    return callback();
                }
                // Check for a valid SOI (Start Of Image) marker.
                if (view.getUint16(0, false) !== CONSTS.SOI_MARKER) {
                    return callback();
                }

                var length = view.byteLength, offset = 2;

                // loop throw all data
                while (offset < length) {

                    // no EXIF data found
                    if (view.getUint16(offset + 2, false) <= 8) {
                        return callback();
                    }

                    var marker = view.getUint16(offset, false);
                    offset += 2;

                    // The first thing we want to find is the APP1 marker (Application marker segment 1)
                    // This is the EXIF Attribute information marker
                    // APP1 contains (by order)
                    // maker, length, Exif identification code, TIFF header, and usually 2 image file directories (IFDs)
                    if (marker === CONSTS.APP1_MARKER) {

                        // check for the Exif header, which is always the 4 bytes 0x45, 0x78, 0x69, 0x66
                        if (view.getUint32(offset += 2, false) !== CONSTS.EXIF_HEADER_MARKER) {
                            return callback();
                        }

                        // test for TIFF validity and endianness - check if big or little endian..
                        //Once we know we are at APP1 we can move on to the TIFF header which starts with the byte alignment,
                        //0x4949 (II, Intel) or 0x4D4D (MM, Motorola), Intel being little endian and Motorola being big endian.
                        var little = view.getUint16(offset += 6, false) === CONSTS.TIFF_HEADER_MARKER;
                        offset += view.getUint32(offset + 4, little);

                        var tags = _parsTiffTags(view, offset, little);
                        return callback(tags);
                    }
                    // not defined
                    else if ((marker & 0xFF00) != 0xFF00) {
                        break;
                    }
                    else {
                        offset += view.getUint16(offset, false);
                    }
                }
                callback();
            };

            try {
                reader.readAsArrayBuffer(file);
            }
            catch (e) {
                callback();
            }
        }

        /**
         * parsing the tiff tags to mapped object
         * @param dataView
         * @param offset
         * @param little
         * @private
         */
        function _parsTiffTags(dataView, offset, little) {

            var tags = dataView.getUint16(offset, little);
            offset += 2;

            var mapped = {};

            for (var i = 0; i < tags; i++) {
                var offsetToCheck = offset + (i * 12);
                var currentTag = dataView.getUint16(offsetToCheck, little);
                var currentValue = dataView.getUint16(offsetToCheck + 8, little);
                mapped[currentTag] = currentValue;
            }
            return mapped;
        }

        /**
         * create the image thumbnail
         * @param selectedImage
         * @param callback
         * @private
         */
        function createThumbnail(selectedImage, callback) {
            var reader = new FileReader();

            reader.onload = function (event) {

                var img = new Image();

                img.onload = function () {

                    var resizeCanvas = document.createElement('canvas'),
                        resizeCanvasContext = resizeCanvas.getContext('2d'),
                        ratio = Math.max(CONSTS.MAX_THUMB_HEIGHT / img.height, CONSTS.MAX_THUMB_WIDTH / img.width);

                    resizeCanvas.height = img.height * ratio;
                    resizeCanvas.width = img.width * ratio;

                    resizeCanvasContext.drawImage(img, 0, 0, resizeCanvas.width, resizeCanvas.height);

                    var data = resizeCanvas.toDataURL(CONSTS.THUMB_FORMAT);

                    if (callback) {
                        callback(data);
                    }

                };

                img.onerror = function () {
                    callback();
                };

                img.src = event.target.result;

            };
            reader.readAsDataURL(selectedImage);
        }

        return {
            fixOrientation: fixOrientation,
            createThumbnail: createThumbnail,
            getImageOrientation: getImageOrientation
        };
    };

    return ImageParsingHelper;
});
